import { Input, Select, message } from "antd";
import { MoveLeft, UserPlus } from "lucide-react";
import React, { useState } from "react";
import { downloadCSV } from "../../../CsvTemplate";
import BatchCsvUpload from "../../../BatchCsvUpload";
import WebUtils from "../../../../utils/WebUtils";
import Utils from "../../../../utils/Utils";
import {
  addSingleCandidatetoBatch,
  addBulkCandidatestoBatch,
} from "../../../../api/globalAdmin/Index";
import StudentAddedSuccessModal from "./StudentAddedSuccessModal";
import StudentsBulkUploadModal from "./StudentsBulkUploadModal";

function CreateStudents({
  setCreateBatchFlag,
  batches = [],
  selectedBatch,
  setRefressGetApi,
  setLoading,
  loading,
  setActiveTab,
  batchDetails,
}) {
  const userDetail = Utils.getUserDetail();
  const [createdSuccessFlag, setCreatedSuccessFlag] = useState(false);
  const [bulkUploadFlag, setBulkUploadFlag] = useState(false);
  // const [selectedBatch, setSelectedBatch] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [studentId, setStudentId] = useState("");
  const [open, setOpen] = useState(false);
  const [bulkUploadRes, setBulkUploadRes] = useState(null);

  const createNew = async (studentData) => {
    const url = `${addBulkCandidatestoBatch}`;
    let req = {
      organizationId: userDetail?.organizationId,
      batchIdentifier: selectedBatch,
      userIdentifier: userDetail?.userIdentifier,
      bulkB2BCandidateDetails: studentData,
      emailRequired: true,
    };
    setLoading(true);
    WebUtils.httpOperations(url, req, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setBulkUploadRes(result.data?.data);
          setOpen(false);
          setTimeout(() => {
            setBulkUploadFlag(true);
          }, 200);
        } else {
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const addSingleStudent = async (data) => {
    const url = `${addSingleCandidatetoBatch}`;
    let req = {
      organizationId: userDetail?.organizationId,
      batchIdentifier: selectedBatch,
      userIdentifier: userDetail?.userIdentifier,
      firstName: data?.firstName,
      lastName: data?.lastName,
      mobileNumber: null,
      countryCode: null,
      studentId: data?.studentId,
      emailId: data?.email,
      emailRequired: true,
    };
    setLoading(true);
    WebUtils.httpOperations(url, req, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setOpen(false);
          setTimeout(() => {
            setCreatedSuccessFlag(true);
          }, 200);
        } else {
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const validateForm = () => {
    if (!selectedBatch) {
      message.error("Please select a batch");
      return false;
    }
    if (!firstName.trim()) {
      message.error("Please enter first name");
      return false;
    }
    if (!lastName.trim()) {
      message.error("Please enter last name");
      return false;
    }
    if (!email.trim()) {
      message.error("Please enter email");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      message.error("Please enter a valid email address");
      return false;
    }
    return true;
  };

  const prepareRequestBody = () => {
    return {
      batchId: selectedBatch,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.trim().toLowerCase(),
      studentId: studentId.trim(),
      fullName: `${firstName.trim()} ${lastName.trim()}`,
      createdAt: new Date().toISOString(),
    };
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    const reqBody = prepareRequestBody();
    addSingleStudent(reqBody);
  };

  const resetForm = () => {
    // setSelectedBatch(null);
    setFirstName("");
    setLastName("");
    setEmail("");
    setStudentId("");
  };

  const handleClearForm = () => {
    resetForm();
  };

  const users = [
    {
      firstName: "Akhil",
      lastName: "Sravan",
      email: "dummy@123mail.com",
      studentId: 2,
    },
  ];

  const customCsvData = users.map((item, index) => ({
    "First Name": item.firstName,
    "Last Name": item.lastName,
    Email: item.email,
    "Student Id": item.studentId,
  }));

  return (
    <>
      {createdSuccessFlag && (
        <StudentAddedSuccessModal
          setCreatedSuccessFlag={setCreatedSuccessFlag}
          createdSuccessFlag={createdSuccessFlag}
          setCreateBatchFlag={setCreateBatchFlag}
          setRefressGetApi={setRefressGetApi}
        />
      )}
      {bulkUploadFlag && (
        <StudentsBulkUploadModal
          setBulkUploadFlag={setBulkUploadFlag}
          bulkUploadFlag={bulkUploadFlag}
          setCreateBatchFlag={setCreateBatchFlag}
          setActiveTab={setActiveTab}
          bulkUploadRes={bulkUploadRes}
        />
      )}
      <div className="max-w-[600px] mx-auto mt-5">
        <p className="header-text text-center underline">Add Student</p>

        {/* Batch Dropdown */}
        <div className="mt-4">
          <p className=" text-center font-medium">
            {batchDetails?.batchName}{" "}
            <span className="text-gray-600 text-[.8rem]">
              ({batchDetails?.batchIdentifier}){" "}
            </span>
          </p>
          {/* <p className="sub-text-color text-[.85rem] font-semibold">
            Batch <span className="text-red-500">*</span>
          </p> */}
          {/* <Input value={selectedBatch} readOnly  className="mt-1 py-2" /> */}
          {/* <Select
            className="w-full mt-1 h-[37px]"
            placeholder="Select a batch"
            labelInValue
            disabled
            value={
              selectedBatch
                ? {
                    value: selectedBatch,
                    label: (
                      <div className="font-normal text-black">
                        <span className="font-normal text-gray-500">
                          {selectedBatch}
                        </span>
                      </div>
                    ),
                  }
                : undefined
            }
            options={batches.map((batch) => ({
              value: batch.batchIdentifier,
              label: `${batch.batchName} (${batch.batchIdentifier})`,
            }))}
          /> */}
          {/* <Select
            className="w-full mt-1 h-[37px]"
            placeholder="Select a batch"
            value={selectedBatch}
            onChange={setSelectedBatch}
            options={batches.map((batch) => ({
              label: batch.name,
              value: batch.id,
            }))}
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          /> */}
        </div>

        {/* First Name & Last Name - 50/50 layout */}
        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="sub-text-color text-[.85rem] font-semibold">
              First Name <span className="text-red-500">*</span>
            </p>
            <Input
              className="mt-1 py-[.35rem]"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="Enter first name"
            />
          </div>
          <div>
            <p className="sub-text-color text-[.85rem] font-semibold">
              Last Name <span className="text-red-500">*</span>
            </p>
            <Input
              className="mt-1 py-[.35rem]"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Enter last name"
            />
          </div>
        </div>

        {/* Email & Student ID - 50/50 layout */}
        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="sub-text-color text-[.85rem] font-semibold">
              Email <span className="text-red-500">*</span>
            </p>
            <Input
              className="mt-1 py-[.35rem]"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="student@example.com"
            />
          </div>
          <div>
            <p className="sub-text-color text-[.85rem] font-semibold">
              Student ID
            </p>
            <Input
              className="mt-1 py-[.35rem]"
              value={studentId}
              onChange={(e) => setStudentId(e.target.value)}
              placeholder="Enter student ID"
            />
          </div>
        </div>

        {/* CSV Upload Info */}
        <div className="mt-6 sub-text-color text-[.85rem]">
          Want to add multiple students at once?{" "}
          <span
            onClick={() => downloadCSV(customCsvData, "students_template.csv")}
            className="text-[#DC6803] border-b-[1px] border-[#DC6803] cursor-pointer pb-[1px] font-semibold hover:brightness-110 transition-all duration-200 ease-in-out"
          >
            Download the CSV template
          </span>
          , fill in the required details, and{" "}
          <BatchCsvUpload
            createNew={createNew}
            open={open}
            setOpen={setOpen}
            type="STUDENT"
          >
            <span className="text-[#DC6803] border-b-[1px] border-[#DC6803] cursor-pointer pb-[1px] font-semibold hover:brightness-110 transition-all duration-200 ease-in-out">
              Click to upload the file
            </span>
          </BatchCsvUpload>{" "}
          here.
        </div>
        <div className="mt-3 sub-text-color text-[.85rem]">
          Note: Adding students will automatically create accounts and send
          login credentials to their registered email addresses.
        </div>

        {/* Buttons */}
        <div className="mt-5 flex justify-between">
          <button
            onClick={() => setCreateBatchFlag(false)}
            className="flex gap-2 items-center text-[.875rem] hover:text-amber-500 transition-all duration-200"
          >
            <MoveLeft size={16} /> Go back
          </button>
          <div className="flex gap-3">
            {/* <button
            onClick={handleClearForm}
            className="px-4 py-[.35rem] rounded-lg text-[.85rem] border border-gray-300 hover:bg-gray-50 transition"
          >
            Clear
          </button> */}
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="btn-orange px-4 py-[.35rem] rounded-lg text-[.875rem] flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Add Student
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreateStudents;
